function clearTimer(timer) {
  if(timer){
    clearTimeout(timer);
    timer = null;
  }
}

export default clearTimer;